define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 视频播放模式。
     *
     * @exports EnumVideoPlayMode
     * 
     * @see VideoFusion#playMode
     */
    var EnumVideoPlayMode = {
        /**
         * 自动。
         * @type {Number}
         * @constant
         */
        AUTO: 0,

        /**
         * 外部控制。
         * @type {Number}
         * @constant
         */
        CTRL: 1
    }
    freezeObject(EnumVideoPlayMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumVideoPlayMode) {
            if (EnumVideoPlayMode.hasOwnProperty(key) && EnumVideoPlayMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        AUTO: 0,
        CTRL: 1,
        getName: getName
    }
})